/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createTeamRoleRequestSchema = z.object({
  isCritical: z.boolean().nullish(),
  isDefault: z.boolean().nullish(),
  name: z.string().min(1),
});
